import React from 'react';
import styled from 'styled-components';

import { Flex, Typo, Icon, Button, theme } from '../../../ui';
import { AttachmentList } from '../../../ui';
import { useTranslation } from 'react-i18next';

const FeedbackContainer = styled.div`
  display:flex;
  margin:16px 0;
  align-items:flex-start;
  gap:15px;
  background-color: ${theme.colors.PRIMARY_LIGHT};
  width: 100%;
  padding: 10px;
  padding-bottom: 20px;
`
const IconWrapper = styled.div`
  display: flex;
  padding-top: 4px;
`

const StyledButton = styled(Button)`
  align-self: flex-end;
`

const TeacherFeedback = ({ feedback, handleOpenFeedback }) => {
  const { t } = useTranslation();

  return (
    feedback?.created ?
      <>
        <FeedbackContainer>
          <IconWrapper>
            <Icon.Feedback size='small' color={theme.colors.NEU_600} />
          </IconWrapper>
          <Flex gap='10' direction='column' align='flex-start' >
            <Flex direction='column' align='flex-start' gap='10'>
              <Typo.Text>{feedback?.text}</Typo.Text>
              <Typo.Info>{feedback?.created}</Typo.Info>
              <AttachmentList files={feedback.files} />
            </Flex>
          </Flex>

        </FeedbackContainer>
        {!!handleOpenFeedback && <StyledButton onClick={handleOpenFeedback}>{t('tasks.editFeedback')}</StyledButton>}
      </>
      : !!handleOpenFeedback && <StyledButton onClick={handleOpenFeedback}>{t('tasks.giveFeedback')}</StyledButton>

  );
};

export default TeacherFeedback;
